// extracted by mini-css-extract-plugin
export default {"selectedTimelight":"genre_selectedTimelight__DAgCA","selectedTimedark":"genre_selectedTimedark__XuuDX","btnView":"genre_btnView__MH8dh"};